// @ngInject
function ResellerOrdersApiService($q, $window, $cookies, DS, DSHttpAdapter, ResourcesService) {
    var endpoint = 'resellerorders';

    return {
        applyFulfillResellerOrders: applyFulfillResellerOrders,
        getResellerOrders: getResellerOrders,
        getResellerReturnOrders: getResellerReturnOrders,        
        getAllResellerOrders: getAllResellerOrders,
        create: createOrder,
        createReturnOrder: createResellerReturnOrder,
        createResellerReturnOrderBasedOnOrder: createResellerReturnOrderBasedOnOrder,
        changeOrderNumber: changeOrderNumber,
        confirm: confirmOrder,
        confirmFulfillmentLineItemPicking: confirmFulfillmentLineItemPicking,
        deleteResellerOrder: deleteResellerOrder,
        deleteOrder: deleteOrder,
        getFulfillableProducts: getFulfillableProducts,
        getFulfilledOrders: getFulfilledOrders,
        getFulfilledProducts: getFulfilledProducts,
        getFulfillableLineItems: getFulfillableLineItems,
        getFulfillableOrders: getFulfillableOrders,
        getOrderById: getOrderById,
        getReturnOrderById: getReturnOrderById,
        getOrderHeaderById: getOrderHeaderById,
        getReturnOrderProducts:getReturnOrderProducts,
        getWarehouses: ResourcesService.apiFactory.get(endpoint + '/warehouses'),
        getStores: ResourcesService.apiFactory.get(endpoint + '/stores'),
        getResellers: ResourcesService.apiFactory.get(endpoint + '/resellers'),
        getOrderCollections: ResourcesService.apiFactory.get(endpoint + '/ordercollections'),
        getProducts: getProducts,
        getVariantsForProduct: getVariantsForProduct,
        upsertLineItems: upsertLineItems,
        getResellerOrderPdf: getResellerOrderPdf,
        getSelectedResellerOrderPdf: getSelectedResellerOrderPdf,
        getSelectedResellerOrderZip: getSelectedResellerOrderZip,
        getAllSearchedResellerOrderZip:getAllSearchedResellerOrderZip,
        getResellerOrderCsv: getResellerOrderCsv,
        setWholeOrderDeliverDate: setWholeOrderDeliverDate,
        setWholeOrderDiscountPercent: setWholeOrderDiscountPercent,
        setOrderDeliveryAddress: setOrderDeliveryAddress,
        setOrderInvoiceAddress: setOrderInvoiceAddress,
        getResellerOrderOrderPerspectivePickingList: getResellerOrderOrderPerspectivePickingList,
        getResellerOrderProductPerspectivePickingList: getResellerOrderProductPerspectivePickingList,
        getResellerOrderDeliveryOrder: getResellerOrderDeliveryOrder,
        getResellerOrderInvoice: getResellerOrderInvoice,
        getResellerOrderDeliveryNote: getResellerOrderDeliveryNote,
        getResellerOrderByOrderNumber: getResellerOrderByOrderNumber,
        setVariantFufillmentDeliveryDate : setVariantFufillmentDeliveryDate,
        getAllResellerOrdersPdf: getAllResellerOrdersPdf,
        createSalesOnClosedFulfillmentLineItems: createSalesOnClosedFulfillmentLineItems,
        setResellerReturnOrderSaleDate:setResellerReturnOrderSaleDate,
        // deleteResellerOrder: ResourcesService.apiFactory.delete(endpoint + '/id?'),
    };

    function getAllSearchedResellerOrderZip(request){
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/searched/zip', request, { responseType: 'arraybuffer' }).then(function (response) {
            var blob = new Blob([response.data], {type: 'application/zip'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'ResellerOrders.zip');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getSelectedResellerOrderZip(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/selected/zip', request, { responseType: 'arraybuffer' }).then(function (response) {
            var blob = new Blob([response.data], {type: 'application/zip'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'ResellerOrders.zip');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getSelectedResellerOrderPdf(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/selected/pdf', request, { responseType: 'arraybuffer' }).then(function (response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'ResellerOrders.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function setResellerReturnOrderSaleDate(request) {
        var deferred = $q.defer();
        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/returnorder/sales', request).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.resolve(handleError);
        });

        return deferred.promise;
    }

    function setVariantFufillmentDeliveryDate(request){
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/plannedDeliveryDate', request).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }
    function setOrderDeliveryAddress(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/' + request.orderId + '/deliveryaddressadjustment', request).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }
    function setOrderInvoiceAddress(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/' + request.orderId + '/invoiceaddressadjustment', request).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function setWholeOrderDeliverDate(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/' + request.orderId + '/deliverydateadjustment', request).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }
    function setWholeOrderDiscountPercent(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/' + request.orderId + '/discountpercentadjustment', request).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function applyFulfillResellerOrders(lineItems) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/fulfillments', lineItems).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getFulfillableProducts(request) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/fulfillableproducts/warehouse/' + request.warehouseId, { params: request }).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getFulfilledOrders(request) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/fulfilledorders/warehouse/' + request.warehouseId, { params: request }).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getFulfilledProducts(request) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/fulfilledproducts/warehouse/' + request.warehouseId, { params: request }).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getFulfillableLineItems(warehouseId, minimumAvailableStock, articleId, articleVariantDetail1Id) {
        var deferred = $q.defer();

        var request = {
            warehouseId: warehouseId,
            minimumAvailableStock: minimumAvailableStock,
            articleId: articleId,
            articleVariantDetail1Id: articleVariantDetail1Id
        };

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/fulfillablelineitems/warehouse/' + warehouseId + '/article/' + articleId + '/articleVariantDetail1Id/' + articleVariantDetail1Id, { params: request }).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getFulfillableOrders(warehouseId, minimumAvailableStock, articleId, articleVariantDetail1Id) {
        var deferred = $q.defer();

        var request = {
            warehouseId: warehouseId,
            minimumAvailableStock: minimumAvailableStock,
            articleId: articleId,
            articleVariantDetail1Id: articleVariantDetail1Id
        };

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/fulfillableorders/warehouse/' + warehouseId + '/article/' + articleId + '/articleVariantDetail1Id/' + articleVariantDetail1Id, { params: request }).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getResellerOrders(currentPage, searchTerm, itemsPerPage, orderStatuses, isFilterOrderForInvoice) {
        var deferred = $q.defer();

        var params = {
            page: currentPage,
            filter: searchTerm,
            Limit: itemsPerPage,
            order: null,
            orderStatuses: orderStatuses,
            isFilterOrderForInvoice: isFilterOrderForInvoice
        };

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint, { params: params }).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getResellerReturnOrders(currentPage, searchTerm, itemsPerPage, orderStatuses) {
        var deferred = $q.defer();

        var params = {
            page: currentPage,
            filter: searchTerm,
            Limit: itemsPerPage,
            order: null,
            orderStatuses: orderStatuses
        };

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/returnOrders', { params: params }).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getAllResellerOrders(currentPage, searchTerm, itemsPerPage, orderStatuses) {
        var deferred = $q.defer();

        var params = {
            page: currentPage,
            filter: searchTerm,
            Limit: itemsPerPage,
            order: null,
            orderStatuses: orderStatuses
        };

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/allOrders', { params: params }).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }


    function getVariantsForProduct(orderId, productId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/' + orderId + '/products/' + productId + '/variants').then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getProducts(orderId, filter) {
        var deferred = $q.defer();

        var params = {
            filter: filter
        };

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/' + orderId + '/products/', { params: params }).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }
    function getReturnOrderProducts(orderId, filter) {
        var deferred = $q.defer();

        var params = {
            filter: filter
        };

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/' + orderId + '/returnorder/products/', { params: params }).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }
    function upsertLineItems(lineItems) {
        var deferred = $q.defer();

        var jsonRequest = JSON.stringify(lineItems);

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/' + lineItems.orderId + '/lineitems', jsonRequest).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function changeOrderNumber(newOrderNumber, resellerOrderId) {
        var deferred = $q.defer();

        console.log("Changeing order number to: " + newOrderNumber + " for: " + resellerOrderId);


        var request = {
            ResellerOrderId: resellerOrderId,
            NewOrderNumber: newOrderNumber
        };

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/changeOrderNumber', request).then(function (response){
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function createOrder(resellerOrder) {
        var deferred = $q.defer();

        console.log("Creating reseller order: " + resellerOrder);

        var jsonRequest = JSON.stringify(resellerOrder);

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint, jsonRequest).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    
    function createResellerReturnOrder(resellerOrder) {
        var deferred = $q.defer();

        console.log("Creating reseller return order: " + resellerOrder);

        var jsonRequest = JSON.stringify(resellerOrder);

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/returnorder', jsonRequest).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function createResellerReturnOrderBasedOnOrder(resellerOrder) {
        var deferred = $q.defer();

        console.log("Creating reseller return order based on order: " + resellerOrder);
        resellerOrder.externalOrderNumber = resellerOrder.orderNumber;

        var jsonRequest = JSON.stringify(resellerOrder);

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/returnOrderBasedOnOrder', jsonRequest).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function confirmOrder(orderId) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + endpoint + '/' + orderId + "/confirmation").then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deleteResellerOrder(href) {
        var deferred = $q.defer();

        DSHttpAdapter.DEL(DS.defaults.basePath + href).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deleteOrder(orderId) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + endpoint + '/' + orderId + "/closure").then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }


    function getOrderHeaderById(orderId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/' + orderId + "/header").then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getOrderById(orderId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/' + orderId).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }
    function getReturnOrderById(orderId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/' + orderId + '/returnorder/').then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getResellerOrderPdf(orderId, locale) {
        var deferred = $q.defer();

        var request = {
            resellerOrderId: orderId,
            locale: locale
        };

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/' + orderId + '/pdf', request, { responseType: 'arraybuffer' }).then(function (response) {
            var blob = new Blob([response.data], { type: 'application/pdf' });
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'resellerOrder.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getResellerOrderCsv(orderId, locale) {
        var url = $window.URL || $window.webkitURL;
        var deferred = $q.defer();

        var request = {
            resellerOrderId: orderId,
            locale: locale
        };

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/' + orderId + '/csv', request, { responseType: 'arraybuffer' }).then(function (response) {
            //"attachment; filename=20200330-10072-ICA Sverige AB.csv"
            var blob = new Blob([response.data], { type: 'text/csv' });
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'resellerOrder.csv');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var downloadUrl = url.createObjectURL(blob);
                a.href = downloadUrl;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function confirmFulfillmentLineItemPicking(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/pickinglist/confirm', request).then(function (response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getResellerOrderOrderPerspectivePickingList(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/orders/pickinglist', request, { responseType: 'arraybuffer' }).then(function (response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'ResellerOrderPickingList.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }
    function getResellerOrderProductPerspectivePickingList(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/products/pickinglist', request, { responseType: 'arraybuffer' }).then(function (response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'ResellerOrderPickingList.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getAllResellerOrdersPdf(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/all/pdf', request, { responseType: 'arraybuffer' }).then(function (response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'ResellerOrders.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getResellerOrderDeliveryOrder(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'resellerorders/deliveryorderpdf', request, { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'text/plain'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'ResellerOrderDeliveryOrder.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getResellerOrderInvoice(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'resellerorders/invoicepdf', request, { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'text/plain'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'ResellerOrderInvoice.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getResellerOrderDeliveryNote(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'resellerorders/deliveryorderpdf', request, { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'text/plain'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'ResellerOrderDeliveryNote.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;

    }

    function getResellerOrderByOrderNumber(orderNumber) {
        var deferred = $q.defer();

        var request = {
            resellerOrderNumber: orderNumber
        };

        DSHttpAdapter.POST(DS.defaults.basePath + 'resellerorders/ordernumber', request).then(function(response) {
            var order = response.data.order;
            deferred.resolve(order);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getFileName(contentDisposition, defaultValue) {
        //"attachment; filename=PickingList36012-36013.pdf"
        var filename = defaultValue;
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            var filenameRegex = /(?![=]{1})([\w\d\s-]){1,}.(pdf|csv|xls|xlsx|zip)/ig;
            var matches = new RegExp(filenameRegex).exec(contentDisposition);
            if (matches != null && matches[0]) {
                filename = matches[0];
            }
        }
        return filename;
    }

    function createSalesOnClosedFulfillmentLineItems(orderIds) {
        var request = {
            orderIds: orderIds
        };

        var deferred = $q.defer();
        DSHttpAdapter.POST(DS.defaults.basePath + 'resellerorders/sales', request).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });
        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('resellerorder.api', [])
    .factory('ResellerOrdersApiService', ResellerOrdersApiService);
